import React, { PureComponent } from 'react';
import {
  Col,
  Popconfirm,
  Row,
  Switch,
  Form,
  Input,
  Button,
  Badge,
  Popover,
} from 'antd';
import { EditFilled, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import WebhookModal from './WebhookModal';
import { confirmDelete } from '../../../../shared-components/DeleteConfirm';
import styles from './profile.module.sass';
import MTeamsIcon from './../../../../assets/icons/MTeamsIcon.svg';
import SlackIcon from './../../../../assets/icons/SlackIcon.svg';
import SplunkIcon from './../../../../assets/icons/SplunkIcon.svg';
import Modal from 'antd/lib/modal/Modal';

class IntegrationPreferences extends PureComponent {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  state = {
    currentIntegration: null,
    currentSlackIntegration: null,
    currentMTeamsIntegration: null,
    showModal: false,
    currentIntegrationType: '',
    searchQuery: '',
  };

  // componentDidMount() {
  //   const { status } = this.props;
  //   if (status === STATUS.IDLE) {
  //     this.props.loadDepartments();
  //   }
  // }

  handleSlackCreateClick = () => {
    this.setState({ showModal: true, currentIntegrationType: 'Slack' });
  };

  handleMTeamsCreateClick = () => {
    this.setState({ showModal: true, currentIntegrationType: 'MTeams' });
  };

  handleModalClose = () => {
    this.setState({
      showModal: false,
      currentSlackIntegration: null,
      currentMTeamsIntegration: null,
      currentIntegrationType: '',
    });
  };

  handleSlackSubmit = (data) => {
    const { currentSlackIntegration } = this.state;
    if (currentSlackIntegration) {
      this.props.updateSlack(
        {
          ...currentSlackIntegration,
          webhook_url: data.webhook_url,
          name: data.name ? data.name : 'Slack Integration',
        },
        currentSlackIntegration.uuid,
      );
    } else {
      this.props.saveSlack({
        webhook_url: data.webhook_url,
        name: data.name ? data.name : 'Slack Integration',
      });
    }
    this.setState({ showModal: false, currentSlackIntegration: null });
  };

  handleMTeamsSubmit = (data) => {
    const { currentMTeamsIntegration } = this.state;
    if (currentMTeamsIntegration) {
      this.props.updateMTeams(
        {
          ...currentMTeamsIntegration,
          webhook_url: data.webhook_url,
          name: data.name ? data.name : 'Microsoft Teams Integration',
        },
        currentMTeamsIntegration.uuid,
      );
    } else {
      this.props.saveMTeams({
        webhook_url: data.webhook_url,
        name: data.name ? data.name : 'Microsoft Teams Integration',
      });
    }
    this.setState({ showModal: false, currentMTeamsIntegration: null });
  };

  handleSlackEditClick = (integration) => {
    this.setState({
      showModal: true,
      currentSlackIntegration: integration,
      currentIntegrationType: 'Slack',
    });
  };

  handleMTeamsEditClick = (integration) => {
    this.setState({
      showModal: true,
      currentMTeamsIntegration: integration,
      currentIntegrationType: 'MTeams',
    });
  };

  handleDeleteClick = (integration) => {
    const { uuid, type } = integration;

    confirmDelete({
      onOk: () => {
        if (type === 'Slack Integration') {
          this.props.deleteSlack(uuid);
        } else if (type === 'Microsoft Teams Integration') {
          this.props.deleteMTeams(uuid);
        } else if (type === 'Splunk Integration') {
          this.props.deleteSplunk(uuid);
        }
      },
    });
  };

  handleSearchQueryChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handleActiveToggle = (integration) => {
    const uuid = integration.uuid;
    this.props.updateSplunk(
      {
        ...integration,
        active: !integration.active,
      },
      uuid,
    );
  };

  handleAddClick = () => {
    this.props.saveSplunk({
      name: 'Splunk Integration',
      active: false,
      connected: false,
      connection_error: '',
      host: '127.0.0.1',
      port: 8069,
      protocol: 'http',
      version: '8.1.1',
      verify: false,
      username: 'adminn',
      password: 'changeme',
      type: 'Splunk Integration',
    });
  };

  // deleteIntegration = (uuid) => {
  //   this.props.deleteSplunk(uuid);
  // };

  handleEditClick = (currentIntegration) => {
    this.setState({ currentIntegration });
  };

  convertBadgeStatusValues = (integration) => {
    return 'success';
  };

  handleSubmit = () => {
    const data = this.form.current?.getFieldsValue();

    this.setState((prevState) => ({
      currentIntegration: {
        ...prevState.currentIntegration,
        name: data.name,
        host: data.host,
        port: data.port,
        protocol: data.protocol,
        version: data.version,
        verify: data.verify,
        username: data.username,
        password: data.password,
        token: data.token,
        type: 'Splunk Integration',
      },
    }));

    this.props.updateSplunk(
      {
        name: data.name ? data.name : 'Splunk Integration',
        active: false,
        connected: false,
        host: '127.0.0.1', // if send diferrent value keeps pending and loading really slow, just for host parameter
        port: data.port,
        protocol: data.protocol,
        version: data.version,
        verify: data.verify,
        username: data.username,
        password: data.password,
        token: data.token,
        connection_error: '',
        type: 'Splunk Integration',
        uuid: this.state.currentIntegration.uuid,
      },
      this.state.currentIntegration.uuid,
    );

    this.handleEditClick(null);

    this.form.current.resetFields();
  };

  getFilteredIntegrations = () => {
    const { splunkSettings, slackSettings, mTeamsSettings } = this.props;

    const integrations = [
      ...splunkSettings,
      ...slackSettings,
      ...mTeamsSettings,
    ];
    const { searchQuery } = this.state;
    const query = searchQuery.trim().toLowerCase();
    if (!query) return integrations;
    return integrations.filter((u) => u.name.toLowerCase().includes(query));
  };

  renderListView = () => {
    // const { status } = this.props;
    const { searchQuery } = this.state;
    // const loading = status === STATUS.LOADING;

    return (
      <>
        <div className={styles.top_section}>
          <Input
            placeholder="Search Integrations"
            prefix={<SearchOutlined />}
            className={styles.search_input}
            onChange={this.handleSearchQueryChange}
            value={searchQuery}
          />
        </div>
        <Row className={styles.table_header}>
          <Col span={3}>Logo</Col>
          <Col span={4} className={styles.integration_table_title}>
            Integration name
            {/* <img src={SortAscendingIcon} style={{ paddingLeft: '14px' }} /> */}
          </Col>
          {/* <Col
            span={6}
            className={styles.integration_table_title}
            onClick={() => console.log('sorting')}
          >
            Last Sync{' '}
            <img src={SortAscendingIcon} style={{ paddingLeft: '14px' }} />
          </Col> */}
          <Col span={4} offset={12}>
            Actions
          </Col>
        </Row>

        {this.getFilteredIntegrations().map((integration) => {
          let badgeStatus = '';
          if (integration.connected) {
            badgeStatus = 'success';
          } else if (!integration.connected) {
            badgeStatus = 'error';
          }

          return (
            <Row
              key={integration.uuid}
              className={styles.table_header}
              style={{ backgroundColor: '#182A30' }}
            >
              <Col span={3}>
                {integration.type === 'Splunk Integration' && (
                  <img
                    style={{ maxWidth: '32px' }}
                    src={SplunkIcon}
                    alt="Splunk Integration - SplunkIcon"
                  />
                )}
                {integration.type === 'Slack Integration' && (
                  <img
                    style={{ maxWidth: '32px' }}
                    src={SlackIcon}
                    alt="Slack Integration - SlackIcon"
                  />
                )}
                {integration.type === 'Microsoft Teams Integration' && (
                  <img
                    style={{ maxWidth: '32px' }}
                    src={MTeamsIcon}
                    alt="Microsoft Teams Integration - MTeamsIcon"
                  />
                )}
              </Col>
              <Col span={4}>
                {integration.name ? integration.name : integration.type}
              </Col>
              {/* <Col span={6}>Date of last sync</Col> */}
              <Col span={5} offset={8}>
                {integration.type === 'Splunk Integration' ? (
                  <Popover
                    placement="bottom"
                    content={
                      <div>
                        <p>
                          {integration.connected
                            ? 'successfully connected'
                            : integration.connectionError +
                              ' Check the connection details.'}
                        </p>
                      </div>
                    }
                    title="Connection details"
                  >
                    <Badge status={badgeStatus} />
                  </Popover>
                ) : (
                  ''
                )}
              </Col>
              <Col span={1}>
                <EditFilled
                  style={{ fontSize: '16px' }}
                  onClick={() => {
                    if (integration.type === 'Splunk Integration') {
                      this.handleEditClick(integration);
                    } else if (integration.type === 'Slack Integration') {
                      this.handleSlackEditClick(integration);
                    } else if (
                      integration.type === 'Microsoft Teams Integration'
                    ) {
                      this.handleMTeamsEditClick(integration);
                    }
                  }}
                />
              </Col>
              {/* <Col span={1}>
                <SyncOutlined
                  style={{ fontSize: '16px' }}
                  onClick={() => console.log('Syncronization')}
                />
              </Col> */}
              <Col span={1}>
                <Popconfirm
                  title={<div style={{ color: '#ccd4d9' }}>Are you sure?</div>}
                  onConfirm={() => this.handleDeleteClick(integration)}
                >
                  <DeleteOutlined style={{ fontSize: '16px' }} />
                </Popconfirm>
              </Col>
            </Row>
          );
        })}

        {/* <div style={{ float: 'right', fontSize: 25, margin: '0 20px 20px' }}>
          <PlusCircleFilled
            style={{ color: 'white', marginTop: 20 }}
            onClick={this.handleAddClick}
          />
        </div> */}

        <h3 className={styles.footer_title}>Add More Integrations</h3>
        <div style={{ display: 'flex' }}>
          <div
            className={styles.availible_integration}
            onClick={this.handleSlackCreateClick}
          >
            <img style={{ width: '48px' }} src={SlackIcon} alt="Slack Icon" />
            <span>Slack</span>
          </div>
          <div
            className={styles.availible_integration}
            onClick={this.handleMTeamsCreateClick}
          >
            <img
              style={{ width: '48px' }}
              src={MTeamsIcon}
              alt="Microsoft Teams Icon"
            />
            <span>Microsoft Teams</span>
          </div>
        </div>
      </>
    );
  };

  renderDetailView = () => {
    const { currentIntegration } = this.state;
    return (
      <Modal
        title="Splunk Integration"
        className={styles.modal}
        visible
        onCancel={() => this.handleEditClick(null)}
        footer={[
          <Button key="cancel" onClick={() => this.handleEditClick(null)}>
            Cancel
          </Button>,

          <Button key="submit" type="primary" onClick={this.handleSubmit}>
            {currentIntegration ? 'Update' : 'Integrate'}
          </Button>,
        ]}
      >
        <Form
          ref={this.form}
          className={styles.form}
          name="control-ref"
          initialValues={{
            name: currentIntegration?.name,
            host: currentIntegration?.host,
            port: currentIntegration?.port,
            protocol: currentIntegration?.protocol,
            version: currentIntegration?.version,
            verify: currentIntegration?.verify,
            username: currentIntegration?.username,
            password: currentIntegration?.password,
            token: currentIntegration?.token,
          }}
        >
          <Form.Item
            className={styles.form_item}
            label="Integration name"
            labelCol={{ span: 24 }}
            name="name"
          >
            <Input />
          </Form.Item>
          <div className={styles.form_item_container}>
            <Form.Item
              className={styles.form_item}
              label="Host"
              labelCol={{ span: 24 }}
              name="host"
              style={{ marginRight: '8px', padding: '0' }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              className={styles.form_item}
              labelCol={{ span: 24 }}
              label="Port"
              name="port"
            >
              <Input />
            </Form.Item>
          </div>
          <div className={styles.form_item_container}>
            <Form.Item
              className={styles.form_item}
              style={{ marginRight: '8px' }}
              labelCol={{ span: 24 }}
              label="Protocol"
              name="protocol"
            >
              <Input />
            </Form.Item>
            <Form.Item
              className={styles.form_item}
              labelCol={{ span: 24 }}
              name="version"
              label="Version"
            >
              <Input />
            </Form.Item>
          </div>
          <Form.Item
            className={styles.form_item}
            name="verify"
            label="Verify"
            valuePropName="checked"
          >
            <Switch defaultChecked={currentIntegration.verify} />
          </Form.Item>
          <div className={styles.form_item_container}>
            <Form.Item
              className={styles.form_item}
              style={{ marginRight: '8px' }}
              labelCol={{ span: 24 }}
              name="username"
              label="Username"
              dependencies={['password', 'token']}
              rules={[
                {
                  //required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              className={styles.form_item}
              labelCol={{ span: 24 }}
              name="password"
              label="Password"
              dependencies={['username', 'token']}
              rules={[
                {
                  //required: true,
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </div>
          <Form.Item
            className={styles.form_item}
            labelCol={{ span: 24, padding: '0px' }}
            name="token"
            label="Token"
            dependencies={['username', 'password']}
            rules={[
              {
                //required: true,
                //message: 'Please confirm your password!',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value && getFieldValue('password') === '') {
                    return Promise.reject('Enter username/password, or token!');
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  render() {
    const {
      currentIntegration,
      currentSlackIntegration,
      currentMTeamsIntegration,
      showModal,
      currentIntegrationType,
    } = this.state;
    // const { status } = this.props;
    // const { showModal, selectedDepartment, searchQuery } = this.state;
    // const loading = status === STATUS.LOADING;

    return (
      <div>
        <WebhookModal
          show={showModal}
          onCancel={this.handleModalClose}
          onSlackSubmit={this.handleSlackSubmit}
          onMTeamsSubmit={this.handleMTeamsSubmit}
          currentSlackIntegration={currentSlackIntegration}
          currentMTeamsIntegration={currentMTeamsIntegration}
          currentIntegrationType={currentIntegrationType}
        />
        {this.renderListView()}
        {currentIntegration && this.renderDetailView()}
      </div>
    );
  }
}

export default IntegrationPreferences;
